import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CollectionsNames } from 'src/app/definitions/collections-names';
import { StateManagerService } from 'src/app/services/state-manager.service';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['./customer-details.component.scss'],
})
export class CustomerDetailsComponent implements OnInit {
    @Output() customerChange: EventEmitter<DocumentModel> = new EventEmitter();
    @Input() document: DocumentModel;
    display = false;
    buttonText = 'Show';
    depots: any[];

    constructor(private stateManager: StateManagerService,
        private collectionNames: CollectionsNames) {
    }

    ngOnInit() {
        this.populateDepotList();
    }

    populateDepotList(){
        this.depots = this.stateManager.getCollection(this.collectionNames.DEPOT);
    }


    getDepotName( cod : number ){
        var depotName = 'Unknown';
        const xname = this.depots.filter( depot => {
            return depot.cod === cod;
        });

        if(xname.length === 1){
            depotName = xname[0].descr;
        }
        return depotName;
    }
}
